/* ================= gallery ================= */
function goMedia(i){
  document.querySelectorAll('.gal-main .slide').forEach(function(s,n){s.classList.toggle('on',n===i)});
  document.querySelectorAll('.thumbs .thumb').forEach(function(t,n){t.classList.toggle('on',n===i)});
  document.querySelectorAll('.ml-info').forEach(function(x,n){x.hidden=n!==i});
  var v=document.getElementById('pdpVid');
  if(v){ if(i===2){ v.play().catch(function(){}); } else { v.pause(); } }
}
function togVid(card){
  var v=card.querySelector('video'); if(!v) return;
  var pp=card.querySelector('.pp');
  if(v.paused){ v.play().catch(function(){}); if(pp) pp.innerHTML='&#10074;&#10074;'; }
  else { v.pause(); if(pp) pp.innerHTML='&#9658;'; }
}

/* ================= main buy box ================= */
var SUB_OFF=0;                       // subscribe & save
var QTY_TIERS={};   // no buy-more tiers (removed Sep 14)
var sz={g:1,price:20.00}, plan='once', q=1;
function money(n){ return '$'+n.toFixed(2); }
function tierOff(n){ var best=0; for(var k in QTY_TIERS){ if(n>=+k) best=Math.max(best,QTY_TIERS[k]); } return best; }
function unitPrice(){ return plan==='sub' ? sz.price*(1-SUB_OFF) : sz.price; }
function render(){
  var unit=unitPrice(), off=tierOff(q), total=unit*q*(1-off);
  (function(e,t){if(e)e.textContent=t;})(document.getElementById('onceP'),money(sz.price));
  (function(e,t){if(e)e.textContent=t;})(document.getElementById('subP'),money(sz.price*(1-SUB_OFF)));
  var qe=document.getElementById('qEcho'); if(qe) qe.textContent=q+(q===1?' jar':' jars')+(off?' \u00b7 '+Math.round(off*100)+'% off':'');
  document.getElementById('addBtn').innerHTML='Add to cart \u00b7 '+money(total);
  var sb=document.getElementById('sbBtn');
  if(sb) sb.innerHTML='Add to cart \u00b7 '+money(total);
  var sm=document.getElementById('sbMeta');
  if(sm){ var szon=document.querySelector('#sizes .sz.on .amt'); sm.innerHTML='<b>'+((window.EL_PDP&&EL_PDP.title)||'')+'</b><span>'+(szon?szon.textContent+' \u00b7 ':'')+'Qty '+q+'</span>'; }
  /* light the tier whose discount is in effect, so +/- moves the box too (4 bags = Buy 3) */
  var tq=0; [].forEach.call(document.querySelectorAll('#qtiers .qt'),function(b){ if(+b.dataset.q<=q) tq=Math.max(tq,+b.dataset.q); });
  [].forEach.call(document.querySelectorAll('#qtiers .qt'),function(b){ b.classList.toggle('on', +b.dataset.q===tq); });
}
function pickSize(el){
  [].forEach.call(document.querySelectorAll('#sizes .sz'),function(b){b.classList.remove('on')});
  el.classList.add('on'); sz={g:+el.dataset.g, price:+el.dataset.price}; if(el.dataset.slide) goMedia(+el.dataset.slide); render();
}
function pickPlan(p){
  plan=p;
  (document.getElementById('planOnce')||document.createElement('i')).classList.toggle('on', p==='once');
  (document.getElementById('planSub')||document.createElement('i')).classList.toggle('on',  p==='sub');
  render();
}
function pickQty(el){ q=+el.dataset.q; document.getElementById('qty').textContent=q; render(); }
function bumpQty(d){ q=Math.max(1,Math.min(99,q+d)); document.getElementById('qty').textContent=q; render(); }

function cartAdd(n){ var c=document.querySelector('.cart-n'); if(c) c.textContent=(parseInt(c.textContent,10)||0)+n; }
function confirmBtn(btn,label,restore){
  if(btn.dataset.busy) return; btn.dataset.busy='1';
  btn.classList.add('added'); btn.innerHTML='\u2713 '+label;
  setTimeout(function(){ btn.classList.remove('added'); delete btn.dataset.busy; restore(); },1500);
}
document.getElementById('addBtn').addEventListener('click',function(e){
  e.preventDefault(); cartAdd(q); confirmBtn(this,'Added to cart',render);
});

/* sticky buy bar: appears once the main CTA scrolls out of view */
(function(){
  var bar=document.getElementById('stickyBuy'), cta=document.getElementById('addBtn');
  if(!bar||!cta) return;
  function sync(){
    var bar=document.getElementById('stickyBuy'), cta=document.getElementById('addBtn'); if(!bar||!cta) return; var r=cta.getBoundingClientRect();  /* re-read: apps can re-render the buy box */
    bar.classList.toggle('on', r.bottom < 0 || (window.innerWidth <= 760 && r.top > window.innerHeight));  /* phones: also before reaching the main button */
  }
  window.addEventListener('scroll',sync,{passive:true});
  window.addEventListener('resize',sync,{passive:true});
  window.addEventListener('load',sync); setTimeout(sync,1200);  /* images and fonts move the button after first paint */
  var sb=document.getElementById('sbBtn');
  if(sb) sb.addEventListener('click',function(e){ e.preventDefault(); cartAdd(q); confirmBtn(this,'Added',render); });
  sync();
})();

/* ================= bundle builder ================= */
var STRAINS=(window.EL_PR_BUNDLE||[]).slice().sort(function(a,b){ return a.price-b.price; });   /* live pre-rolls, built in sections/elevana-product-preroll.liquid; cheapest first */
var TIERS=[{n:4,off:.20},{n:3,off:.15},{n:2,off:.10}];
var picked={};

function tierFor(n){ for(var i=0;i<TIERS.length;i++){ if(n>=TIERS[i].n) return TIERS[i]; } return {n:0,off:0}; }
function countItems(){ var t=0; for(var k in picked) t+=picked[k]; return t; }

function drawPicks(){
  var el=document.getElementById('picks');
  el.innerHTML=STRAINS.map(function(s){
    var n=picked[s.id]||0;
    var right = n>0
      ? '<div class="qmini"><button onclick="pickAdj(\''+s.id+'\',-1)" aria-label="Remove one">−</button><b>'+n+'</b><button onclick="pickAdj(\''+s.id+'\',1)" aria-label="Add one">+</button></div>'
      : '<button class="addbtn" onclick="pickAdj(\''+s.id+'\',1)">ADD +</button>';
    return '<div class="pick'+(n>0?' picked':'')+'">'+
      '<div class="ph"><img src="'+s.img+'" alt="'+s.name+'"></div>'+
      '<div class="meta"><h3>'+s.name+'</h3><p>'+s.note+'</p>'+
      '<div class="tags"><span class="badge '+s.cls+'">'+s.type+'</span>'+
      '<span class="badge b-hybrid" style="background:var(--bg-alt);color:var(--ink-soft)">'+(s.size||'28 g')+' · '+money(s.price)+'</span></div>'+
      flavorSelect(s)+'</div>'+
      right+'</div>';
  }).join('');
}
/* MAD LABS listings carry their in-stock flavors: a small picker chooses which one the bundle adds */
function flavorSelect(s){
  if(!s.flavors||s.flavors.length<2) return '';
  return '<label class="pk-flv"><span>Flavor</span><select onchange="pickFlavor(\''+s.id+'\',this.value)">'+
    s.flavors.map(function(f){ return '<option value="'+f.vid+'"'+(String(f.vid)===String(s.vid)?' selected':'')+'>'+f.name+'</option>'; }).join('')+
    '</select></label>';
}
function pickFlavor(id,vid){
  STRAINS.forEach(function(s){ if(s.id!==id) return;
    s.flavors.forEach(function(f){ if(String(f.vid)===String(vid)){ s.vid=f.vid; s.price=f.price; if(f.img) s.img=f.img; } });
  });
  drawPicks(); syncBundle();
}
function pickAdj(id,d){
  picked[id]=Math.max(0,(picked[id]||0)+d);
  if(picked[id]===0) delete picked[id];
  drawPicks(); syncBundle();
}
function syncBundle(){
  var n=countItems(), t=tierFor(n);
  var gross=0; STRAINS.forEach(function(s){ gross += (picked[s.id]||0)*s.price; });
  var net=gross*(1-t.off);

  document.querySelectorAll('#tiers .tierpill').forEach(function(p){
    p.classList.toggle('hit', n>=+p.dataset.n);
  });

  var nextT=null;
  for(var i=TIERS.length-1;i>=0;i--){ if(n < TIERS[i].n){ nextT=TIERS[i]; break; } }
  var msg=document.getElementById('progMsg');
  if(nextT){ msg.innerHTML='Add <em>'+(nextT.n-n)+' more</em> to unlock '+Math.round(nextT.off*100)+'% off'; }
  else if(n>0){ msg.innerHTML='<em>20% off</em> unlocked — best price'; }
  else { msg.innerHTML='Add <em>2 items</em> to unlock 10% off'; }

  document.getElementById('progFill').style.width=Math.min(100,(n/4)*100)+'%';
  document.getElementById('progCount').textContent=n+' selected';

  document.getElementById('bTotal').textContent=money(net);
  var was=document.getElementById('bWas'), sv=document.getElementById('bSave');
  if(t.off>0){ was.hidden=false; was.textContent=money(gross);
               sv.hidden=false; sv.textContent='You save '+money(gross-net)+' ('+Math.round(t.off*100)+'% off)'; }
  else { was.hidden=true; sv.hidden=true; }

  var b=document.getElementById('bundleBtn');
  if(!b.dataset.busy) b.innerHTML = n===0 ? 'Add bundle to cart' : 'Add '+n+' to cart · '+money(net);
}
document.getElementById('bundleBtn').addEventListener('click',function(e){
  e.preventDefault();
  var n=countItems(); if(n===0) return;
  cartAdd(n); confirmBtn(this,n+' added',syncBundle);
  picked={}; drawPicks();
});

/* ================= marquee ================= */
var MQ=[['🚚','Free Shipping over $79'],['🇺🇸','Nationwide Delivery'],
        ['🪪','No Medical Card Required'],['📦','Fast Discreet Shipping'],
        ['🧪','Lab Tested'],['🌱','Exclusive Genetics'],['✅','21+ Verified']];
(function(){
  var row=MQ.map(function(m){ return '<span><i>'+m[0]+'</i>'+m[1]+'</span>'; }).join('');
  document.getElementById('mqIn').innerHTML=row+row;   // doubled so the -50% loop is seamless
})();

/* ================= reviews (SAMPLE DATA) ================= */
var SAMPLE_REVIEWS=[
 [{s:5,t:'This is by far <b>the best jar I have opened</b> this year. Not a hint of hay, just pine and fuel.',w:'Marcus'},
  {s:5,t:'Grinds up beautifully and <b>burns clean to a white ash</b>. That is the part most places get wrong.',w:'Denise'},
  {s:5,t:'Third order of this strain. <b>Consistent every single time</b>, which is why I stopped shopping around.',w:'Jordan'}],
 [{s:5,t:'Bag appeal is real. <b>Dense, sticky, frosted</b> — the photos on the site are not doing anything clever.',w:'Priya'},
  {s:4,t:'Flower is excellent. Shipping took a day longer than quoted but it arrived <b>packed well and fresh</b>.',w:'A. Whitfield'},
  {s:5,t:'The COA link on the bag actually matched my batch code. <b>First shop I have seen do that properly.</b>',w:'Tomas'}]
];
var rPage=0;
function drawRevs(){
  if(!document.getElementById('rev3')) return;   /* real reviews are server-rendered (elevana-reviews.liquid) */
  document.getElementById('rev3').innerHTML=SAMPLE_REVIEWS[rPage].map(function(r){
    return '<div class="rcard"><div class="s">'+'★'.repeat(r.s)+'</div><p>'+r.t+'</p><div class="who">'+r.w+'</div></div>';
  }).join('');
  document.getElementById('rdots').innerHTML=SAMPLE_REVIEWS.map(function(_,i){
    return '<button class="'+(i===rPage?'on':'')+'" onclick="goRev('+i+')" aria-label="Reviews page '+(i+1)+'"></button>';
  }).join('');
}
function goRev(i){ rPage=i; drawRevs(); }

(function(){ var o=document.querySelector('#sizes .sz.on')||document.querySelector('#sizes .sz'); if(o){ sz={g:+o.dataset.g, price:+o.dataset.price}; if(o.dataset.slide) goMedia(+o.dataset.slide); } })();
render(); drawPicks(); syncBundle(); drawRevs();


/* phones: description clamps to 2 lines (elevana-fix.css); add a Read more toggle when it overflows */
(function(){
  var p=document.querySelector('.p-summary'); if(!p) return;
  var b=document.createElement('button'); b.type='button'; b.className='p-more'; b.textContent='Read more';
  p.insertAdjacentElement('afterend',b);
  function fit(){ if(p.classList.contains('open')) return; b.hidden = p.scrollHeight <= p.clientHeight+2; }
  b.addEventListener('click',function(){ var o=p.classList.toggle('open'); b.textContent=o?'Show less':'Read more'; b.hidden=false; });
  window.addEventListener('resize',fit,{passive:true}); fit();
})();
